<template>
    <div>
        <v-simple-table class="table-layout pa-3">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th>Nhân viên</th>
                        <th>Mã</th>
                        <th>Số contact</th>
                        <th>Số contact đã xử lý</th>
                        <th>Số đơn</th>
                        <th>Tỷ lệ chốt khởi tạo</th>
                        <th>DT khởi tạo</th>
                        <th>DT thành công</th>
                    </tr>
                </thead>
                <template v-if="contentReports.length">
                    <tbody>
                        <tr>   
                            <td class="total-text">Tổng</td>
                            <td class="total-text">Tổng</td>
                            <td class="total-text">{{ formatPrice(total.numberOfContacts) }}</td>
                            <td class="total-text">{{ formatPrice(total.numberOfProcessContacts) }}</td>
                            <td class="total-text">{{ formatPrice(total.numberOfOrders) }}</td>
                            <td class="total-text">{{ total.initLatch + '%' }}</td>
                            <td class="total-text">{{ formatPrice(total.initTurnOver) }}</td>
                            <td class="total-text">{{ formatPrice(total.successTurnOver) }}</td>
                        </tr>
                    </tbody>
                    <tbody v-for="(report, index) in contentReports" :key="index">
                        <tr>   
                            <td :rowspan="report.rowspan">{{ report.fullName }}</td>
                            <td>{{ report.codeSources[0].codeSource }}</td>
                            <td>{{ formatPrice(report.codeSources[0].numberOfContacts) }}</td>
                            <td>{{ formatPrice(report.codeSources[0].numberOfProcessContacts) }}</td>
                            <td>{{ formatPrice(report.codeSources[0].numberOfOrders) }}</td>
                            <td>{{ report.codeSources[0].initLatch + '%' }}</td>
                            <td>{{ formatPrice(report.codeSources[0].initTurnOver) }}</td>
                            <td>{{ formatPrice(report.codeSources[0].successTurnOver) }}</td>
                        </tr>
                        <template v-if="report.rowspan > 1">
                            <tr v-for="i in (report.rowspan - 1)" :key="'row-' + i">
                                <td>{{ report.codeSources[i].codeSource }}</td>
                                <td>{{ formatPrice(report.codeSources[i].numberOfContacts) }}</td>
                                <td>{{ formatPrice(report.codeSources[i].numberOfProcessContacts) }}</td>
                                <td>{{ formatPrice(report.codeSources[i].numberOfOrders) }}</td>
                                <td>{{ report.codeSources[i].initLatch + '%' }}</td>
                                <td>{{ formatPrice(report.codeSources[i].initTurnOver) }}</td>
                                <td>{{ formatPrice(report.codeSources[i].successTurnOver) }}</td>
                            </tr>
                        </template>
                    </tbody>
                </template>
                <tbody v-if="!contentReports.length">
                    <tr>
                        <td colspan="1000">
                            <common-no-result />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    props: {
        contentReports: {
            type: Array,
            default: () => {[]}
        },
        total: {
            type: Object,
            default: () => {}
        }
    },
}
</script>

<style scoped>
/deep/ .table-layout tbody tr {
    height: 48px !important
}

/deep/ table tr td {
    border-bottom: 1px solid #DDDDDD;
}

/deep/ tbody:hover td[rowspan], tr:hover td {
   background: #DDDDDD; 
}

.total-text {
  color: #ff5252;
  font-size: 16px;
}
</style>